import {ActionMenu, Stack, Text} from '@primer/react-brand'
import {useId} from 'react'
import styles from './IndexSort.module.css'
import {t} from '../../../../../lib/utils/localization'

export type SortOption = {
  label: string
  value: string
}

export type IndexSortProps = {
  sortOptions: SortOption[]
  currentSort: string
  onSortChange?: (value: string) => void
}

export function IndexSort({sortOptions, currentSort, onSortChange}: IndexSortProps) {
  const labelId = useId()
  const hintId = useId()

  return (
    <Stack
      direction="horizontal"
      gap={12}
      alignItems="center"
      justifyContent="flex-end"
      className={styles.indexSortWrapper}
    >
      <Text variant="muted" id={labelId}>
        {t('Sort by:')}
      </Text>
      {/* Visually hidden hint for screen readers */}
      <Text id={hintId} className="sr-only">
        {t('Selecting a sort option will reload the page.')}
      </Text>
      <ActionMenu size="small" onSelect={newValue => onSortChange?.(newValue)}>
        <ActionMenu.Button aria-labelledby={`${labelId} ${hintId}`}>
          {t(sortOptions.find(opt => opt.value === currentSort)?.label || 'Sort')}
        </ActionMenu.Button>
        <ActionMenu.Overlay aria-label={t('Sort options')}>
          {sortOptions.map(opt => (
            <ActionMenu.Item key={opt.value} value={opt.value} selected={opt.value === currentSort}>
              {t(opt.label)}
            </ActionMenu.Item>
          ))}
        </ActionMenu.Overlay>
      </ActionMenu>
    </Stack>
  )
}
